"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrHighlightText = void 0;
const react_1 = __importDefault(require("react"));
const FdrHighlightText = props => {
    const { text, substring } = props;
    const keywords = substring.split(/\s/);
    const result = text.replace(new RegExp(`(${keywords.join('|')})`, `gi`), match => `<b>${match}</b>`);
    return react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: result } });
};
exports.FdrHighlightText = FdrHighlightText;
//# sourceMappingURL=index.js.map